import React from 'react';
import Header from '../components/Header';
import Navbar from '../components/Navbar';


const Resume = () => {
  return (
    <div>
        <Navbar/>
        <Header/>
       
    </div>
  );
}

export default Resume;

